/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "button_add": [{
    "type": 0,
    "value": "추가"
  }],
  "button_remove_all": [{
    "type": 0,
    "value": "모두 제거"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var koKR = Object.assign(TranslationProviderComponent, {
  translations
});

export { koKR as k };
//# sourceMappingURL=ko-KR-Cov7CBt9.js.map
